import React, { Component } from 'react'
require('./footer.scss')

import { Get, wrapResponse } from './../../requst'

/** 计算公司 */
const onComputedCompany = () => {
	switch (location.hostname) {
	case 'maihuominiapps.com':
        case 'www.maihuominiapps.com':
			return '蜀ICP备16021322号-6'
	case 'fanmengit.cn':
        case 'www.fanmengit.cn':
            return '蜀ICP备16021322号-4'
        case 'fanmengit.com':
        case 'www.fanmengit.com':
            return '蜀ICP备16021322号-3'
        case 'sclonsee.com':
        case 'www.sclonsee.com':
            return '蜀ICP备16021322号-2'
        case 'fmkjmanager.com':
        case 'www.fmkjmanager.com':
            return '蜀ICP备16021322号-10'
        case 'fmkjfile.com':
        case 'www.fmkjfile.com':
            return '蜀ICP备16021322号-11'
        case 'fmkjadmin.com':
        case 'www.fmkjadmin.com':
            return '蜀ICP备16021322号-12'
        case 'vmall888.com':
        case 'www.vmall888.com':
            return '蜀ICP备16021322号-7'
        case 'vmallvan666.com':
        case 'www.vmallvan666.com':
            return '蜀ICP备16021322号-8'
        case 'vmallvan.com':
        case 'www.vmallvan.com':
            return '蜀ICP备16021322号-9'
        case 'mengbolive.com':
        case 'www.mengbolive.com':
            return '蜀ICP备16021322号-20'
        case 'mbwxlive.com':
        case 'www.mbwxlive.com':
            return '蜀ICP备16021322号-24'
        case 'hsmblive.com':
        case 'www.hsmblive.com':
            return '蜀ICP备16021322号-25'


	default:
	    return '蜀ICP备16021322号'
	}
}

export default class Footer extends React.Component {
	static async getInitialProps(ctx) {
		const [scripts, datas, links] = await Promise.all([
			wrapResponse(Get({ url: 'base/statistics' })),
			wrapResponse(Get({ url: 'base/footer' })),
			wrapResponse(Get({ url: 'base/links' })),
		])
		return { script: scripts[0], data: datas[0], links}
	}

	constructor(props, context) {
		super(props, context)
		this.state = {
			script: '',
		}
	}
	synchronize() {
		return { __html: this.props.script.synchronize }
	}
	asynchronous() {
		return { __html: this.props.script.asynchronous }
	}
	Links() {
		return this.props.links.map((item, index) => (
			<span><a href={item.link} key={index} style={{ color: '#999', lineHeight: '30px' }} className="LinkA">{item.title} </a>|</span>
		))
	}


	render() {
		return (
			<div className="footer">
				<div style={{ width: '1200px', overflow: 'hidden', margin: '0 auto', paddingTop: '81px' }}>
					<div style={{ float: 'left', display: 'flex' }}>
						<div style={{ textAlign: 'left', borderRight: '1px solid #FFFFFF', height: '115px' }}>
							<img style={{ marginRight: '40px', width: '60px' }} src={this.props.data ? this.props.data.logo : null} alt="" />
						</div>
						<div style={{ paddingLeft: '20px' }}>
							<p style={{ fontSize: '14px', color: '#fff' }}>客服电话</p>
							<p style={{ fontSize: '28px', color: '#fff', marginBottom: '10px' }}>028-86052120</p>
							<p style={{ fontSize: '14px', color: '#fff' }}>工作邮箱：<span>395789527@qq.com</span> </p>
							<p style={{ fontSize: '14px', color: '#fff' }}>工作时间：<span>{this.props.data ? this.props.data.uptime : null}</span> </p>
							<p style={{ fontSize: '14px', color: '#fff' }}>公司地址：<span>{this.props.data ? this.props.data.address : null}</span> </p>
						</div>
					</div>
					<div className="CardBox" style={{ float: 'right' }}>
						<div className="CardLine"></div>
						<div className="scanCard" style={{ width: '260px', height: '140px', display: 'flex', alignItems: 'center', paddingLeft: '20px' }}>
							<img style={{ float: 'right' }} src="https://yxt.cdn.maihuominiapps.com/20210830173639.png?imageView2/1/w/110/h/110" alt="" />
						</div>
					</div>
					<div style={{ clear: 'both', paddingTop: '64px', color: '#999999' }}>
						<p>友情链接:{this.props.links ? this.Links() : null}</p>
					</div>
				</div>
				{/*<p dangerouslySetInnerHTML= {this.state.script?this.synchronize():null}></p>
				<p dangerouslySetInnerHTML= {this.state.script?this.asynchronous():null}></p>*/}
				<div style={{ height: '31px', width: '100%', background: '#292c33', color: '#999999', fontSize: '7px', textAlign: 'center', lineHeight: '31px', cursor: 'pointer' }} onClick={() => window.open('https://beian.miit.gov.cn')}>
					{ process.browser && onComputedCompany() }
				</div>
			</div>
		)
	}
}

